import styled from 'styled-components'

export const IconWideAngleBracketSVG = styled.svg`
  ${({ rotate }) => rotate && `transform: rotate(${rotate}deg);`}
`
